var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAm = function SvgAm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE664",
    d: "M18.896 8.963c0-2.9-2.194-5.253-4.898-5.253-2.704 0-4.898 2.353-4.898 5.253s2.194 5.252 4.898 5.252c2.704 0 4.898-2.352 4.898-5.252zm3.089 2.816a.299.299 0 0 1-.188.2l-2.736.966v3.075c0 .1-.047.201-.122.261-.084.06-.178.08-.272.04l-2.736-.944-1.687 2.492A.304.304 0 0 1 14 18a.304.304 0 0 1-.244-.13l-1.687-2.493-2.736.945c-.094.04-.188.02-.272-.04a.342.342 0 0 1-.122-.262v-3.075l-2.736-.965a.299.299 0 0 1-.188-.201.35.35 0 0 1 .038-.292L7.74 8.995 6.053 6.503a.355.355 0 0 1-.038-.292c.028-.1.103-.17.188-.2l2.736-.966V1.97c0-.1.047-.201.122-.261.084-.06.178-.08.272-.04l2.736.944L13.756.121a.306.306 0 0 1 .488 0l1.687 2.492 2.736-.945c.094-.04.188-.02.272.04.075.06.122.161.122.262v3.075l2.736.965c.085.03.16.1.188.201.028.1.018.201-.038.292L20.26 8.995l1.687 2.492a.35.35 0 0 1 .038.292z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343754",
    d: "M9.294 23.056l-.828 2.177h1.7l-.827-2.177h-.045zM11.219 28l-.515-1.356H7.93L7.414 28H5.5l2.81-7h2.125l2.81 7h-2.026zm7.543 0h-1.018l-1.735-5.189h-.045V28h-1.802v-7h2.977l1.175 3.844h.034L19.5 21H22.5v7h-1.959v-5.189h-.044L18.762 28z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/am.069ab895.svg";
export { ForwardRef as ReactComponent };